/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/components/Dashboard';
import Claims from '@/components/Claims';
import Customers from '@/components/Customers';
import Reports from '@/components/Reports';
import Documents from '@/components/Documents';
import Settings from '@/components/Settings';
import HelpContact from '@/components/HelpContact';
import Notifications from '@/components/Notifications';
import LogIn from '@/components/LogIn';
import LogOut from '@/components/LogOut';
import ApplicationDetail from "../components/ApplicationDetail";
import FactoringDetail from "../components/FactoringDetail";
import RepaymentDetail from "../components/RepaymentDetail";
import IslykillMock from "../components/IslykillMock";

Vue.use(Router);

export default new Router({
		mode: 'history',
		routes: [
			{
				path: '/',
				redirect: {path: '/claims'}
			},
			{
				path: "*",
				redirect: {path: '/claims'}
			},
			{
				path: '/claims',
				name: 'Claims',
				component: Claims
			},
			{
				path: '/customers',
				name: 'Customers',
				component: Customers
			},
			{
				path: '/reports/:selection',
				name: 'Reports',
				component: Reports,
				props: true,
			},
			{
				path: '/documents',
				name: 'Documents',
				component: Documents
			},
			{
				path: '/settings',
				name: 'Settings',
				component: Settings
			},
			{
				path: '/help-contact',
				name: 'Help & Contact',
				component: HelpContact
			},
			{
			   path: '/notifications',
			   component: Notifications
			},
			{
				path: '/log-out',
				name: 'Log Out',
				component: LogOut
			},
			{
				path: '/log-in',
				name: 'Log In',
				component: LogIn
			},
			{
				path: '/application/:id',
				name: 'Application detail',
				component: ApplicationDetail,
				props: true
			},
			{
				path: '/factoring/:id',
				name: 'Factoring detail',
				component: FactoringDetail,
				props: true
			},
			{
				path: '/repayment/:id',
				name: 'Repayment detail',
				component: RepaymentDetail,
				props: true
            },
            {
                path: '/islykill',
                name: 'IslykillMock',
                component: IslykillMock
            }
		]
	}
)
